/* import __COLOCATED_TEMPLATE__ from './data-objects-card.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();